import React from 'react'
import { Link } from 'react-router-dom'
import {
  blogImage2,
  blogImage3,
  instaImage1,
  instaImage2,
  instaImage3,
  instaImage4,
  instaImage5,
  instaImage6,
  instaImage7,
  instaImage8,
  instaImage9,
} from '../../assets/images'
import {
  IconSearch, IconSend,
} from '@tabler/icons-react'

export default function BlogSidebar() {

  const categoryItem = [
    {
      title: "eCommerce",
    },
    {
      title: "Microsoft Technologies",
    },
    {
      title: "Creative UX",
    },
    {
      title: "Wordpress",
    },
    {
      title: "Angular JS",
    },
    {
      title: "Enterprise Mobility",
    },
    {
      title: "Website Design",
    },
    {
      title: "HTML5",
    },
    {
      title: "Infographics",
    },
    {
      title: "Wordpress Development",
    },
  ]

  const popularPost = [
    {
      image: blogImage2,
      title: "Apple Introduces Search Ads Basic",
      date: "jun 22, 2018",
      url: "/blog-detail",
    },
    {
      image: blogImage3,
      title: "new rules, more cars, more races",
      date: "jun 8, 2018",
      url: "/blog-detail",
    },
  ]

  const instaPost = [
    {
      image: instaImage1,
    },
    {
      image: instaImage2,
    },
    {
      image: instaImage3,
    },
    {
      image: instaImage4,
    },
    {
      image: instaImage5,
    },
    {
      image: instaImage6,
    },
    {
      image: instaImage7,
    },
    {
      image: instaImage8,
    },
    {
      image: instaImage9,
    },
  ]

  return (
    <div className='flex flex-col gap-30'>
      <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
        <div className='relative w-full overflow-hidden'>
          <button aria-label="search icon" className="absolute top-[50%] translate-y-[-50%] border-r border-border left-[1px] py-[6px] px-[12px] min-h-[33px] bg-bg-light rounded-l-[3px]">
            <IconSearch className="text-text-primary w-[20px] h-[20px] stroke-[1.5]" />
          </button>
          <input type='text' id='search' name='search' placeholder='Search...' className='bg-bg-dark border border-border w-full py-[6px] pr-[12px] pl-60  min-h-[35px] rounded-[4px] placeholder:text-text-secondary focus:outline-none' />
        </div>
      </div>
      <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
        <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
          Categories Clouds
        </p>
        <div className='flex flex-wrap gap-5'>
          {categoryItem.map((item, key) => (
            <button key={key} className='btn btn-outline-primary' >
              {item.title}
            </button>
          ))}
        </div>
      </div>
      <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
        <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
          Popular Posts
        </p>
        {popularPost.map((item, key) => (
          <div key={key} className='mb-30 last:mb-0'>
            <div className='mb-10 flex items-start justify-between flex-wrap gap-5'>
              <Link to={item.url} className='font-medium'>
                {item.title}
              </Link>
              <span className='text-text-secondary'>
                {item.date}
              </span>
            </div>
            <Link to={item.url} className='flex group overflow-hidden'>
              <img src={item.image} width="1100" height="600" alt='blog post' className='w-full lg:h-[260px] object-cover transition-all duration-700 group-hover:scale-[1.02] group-hover:grayscale' />
            </Link>
          </div>
        ))}
      </div>
      <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
        <p className='text-[16px]/[20px] font-medium md:mb-30 mb-20'>
          Instagram Posts
        </p>
        <div className='flex flex-wrap gap-5'>
          {instaPost.map((item, key) => (
            <Link key={key} to={item.url} className='flex'>
              <img src={item.image} width="90" height="90" alt='insta post' className='w-[90px] h-[90px] object-cover' />
            </Link>
          ))}
        </div>
      </div>
      <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
        <p className='text-[16px]/[20px] font-medium mb-5'>
          Email Newsletter
        </p>
        <p className='md:mb-30 mb-20 text-text-secondary'>
          Get our products/news earlier than others, let’s get in touch.
        </p>
        <div className='relative w-full overflow-hidden'>
          <input type='text' id='chatInput' name='chatInput' placeholder='Enter Email...' className='bg-bg-dark border border-border w-full py-[6px] pl-[12px] pr-60  min-h-[35px] rounded-[4px] placeholder:text-text-secondary focus:outline-none' />
          <button aria-label="search icon" className="absolute top-[50%] translate-y-[-50%] border-l border-l-border right-[1px] py-[6px] px-[12px] min-h-[33px] bg-bg-light rounded-r-[3px]">
            <IconSend className="text-text-primary w-[20px] h-[20px] stroke-[1.5]" />
          </button>
        </div>
      </div>
    </div>
  )
}
